import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Option } from "../../../engine/models/models";
import { Globals } from '../../../services/globals';
@Component({
  selector: 'app-discussion-notes',
  templateUrl: './discussion-notes.component.html',
  styleUrls: ['./discussion-notes.component.css']
})
export class DiscussionNotesComponent implements OnInit {

  public option: Option;
  constructor(@Inject(MAT_DIALOG_DATA) public data: Option, public global: Globals) {
    this.option = data;
  }

  clear() {
    this.option.discussionNotes = '';
  }

  ngOnInit(): void { }

}
